// extracted by mini-css-extract-plugin
export default {"menuDialog":"MenuDialog_menuDialog__FexL2","menuDialogMobile":"MenuDialog_menuDialogMobile__5RhIM","close":"MenuDialog_close__BhpfJ"};